module.exports = __webpack_public_path__ + "img/creators2.87adbba4.jpg";